import {NgModule} from '@angular/core';
import {ImagePreloadDirective} from './image-preload.directive';
import {CommonModule} from '@angular/common';

@NgModule({
  imports: [ CommonModule ],
  declarations: [ ImagePreloadDirective ],
  exports: [ ImagePreloadDirective ]
})
export class ImagePreloadModule {}



// WEBPACK FOOTER //
// ./src/app/directives/ImagePreload/image-preload.module.ts